module.exports = __webpack_public_path__ + "static/media/About3.737be813.png";